import { render, staticRenderFns } from "./ModalComission.vue?vue&type=template&id=bb173544&scoped=true&"
import script from "./ModalComission.vue?vue&type=script&lang=js&"
export * from "./ModalComission.vue?vue&type=script&lang=js&"
import style0 from "./ModalComission.vue?vue&type=style&index=0&id=bb173544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb173544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb173544')) {
      api.createRecord('bb173544', component.options)
    } else {
      api.reload('bb173544', component.options)
    }
    module.hot.accept("./ModalComission.vue?vue&type=template&id=bb173544&scoped=true&", function () {
      api.rerender('bb173544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/modals/ModalComission.vue"
export default component.exports